<template>
  <section
    class="game pos-relative bg-color-primary text-on-primary text-align-center bg-position-c bg-size-cover x-large:bg-attachment-fixed"
  >
    <div id="game" class="section-anchor" aria-hidden="true"></div>
    <h2 class="accessible-hide">Play the Game</h2>
    <div class="dot-block" aria-hidden="true"></div>
    <div
      class="game__header pos-relative bg-color-primary text-on-primary text-align-center py-400 px-150 x-large:py-600"
    >
      <div
        class="game__header-text font-weight-600 text-transform-uppercase mb-200 x-large:mb-400"
      >
        Download and Play the Fan Exam App!
      </div>
      <div
        class="game__header-links d-flex align-items-center justify-content-center"
      >
        <div class="text-transform-uppercase font-weight-600">Coming Soon</div>
        <!-- <a class="game__header-link d-inline-flex button --large" href="#0"
          >Apple App Store</a
        >
        <a class="game__header-link d-inline-flex button --large ml-200 x-large:ml-400" href="#0"
          >Google Play Store</a
        > -->
      </div>
      <div class="game__header-arrow pos-absolute" aria-hidden="true">
        <svg class="game__header-arrow-icon pos-absolute" width="48" height="48" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.273 33.818H31V10.91H16.273v22.91zm7.363 6.546a2.451 2.451 0 01-2.454-2.455 2.451 2.451 0 012.454-2.454 2.451 2.451 0 012.455 2.454 2.451 2.451 0 01-2.455 2.455zM30.182 6H17.09A4.092 4.092 0 0013 10.09v27.82A4.092 4.092 0 0017.09 42h13.092a4.092 4.092 0 004.09-4.09V10.09A4.092 4.092 0 0030.183 6z" fill="#000"/><mask id="a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="13" y="6" width="22" height="36"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.273 33.818H31V10.91H16.273v22.91zm7.363 6.546a2.451 2.451 0 01-2.454-2.455 2.451 2.451 0 012.454-2.454 2.451 2.451 0 012.455 2.454 2.451 2.451 0 01-2.455 2.455zM30.182 6H17.09A4.092 4.092 0 0013 10.09v27.82A4.092 4.092 0 0017.09 42h13.092a4.092 4.092 0 004.09-4.09V10.09A4.092 4.092 0 0030.183 6z" fill="#fff"/></mask></svg>
      </div>
    </div>
    <div class="container pos-relative p-300 pt-1100 x-large:pt-1400 x-large:pb-900">
      <div
        class="game__text font-weight-600 text-transform-uppercase mb-150 x-large:mb-600"
      >
        Compete and prove you are the true super fan!
      </div>
      <div class="game__embed pos-relative mb-600">
        <iframe class="d-block" src="https://play.us.theq.live/partner/imgcollege" width="100%" height="100%" frameborder="0" gesture="media" allow="encrypted-media" allowfullscreen></iframe>
        <!-- <img src="@/assets/app_image.png" /> -->
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Game",
  props: ["embed_url", "embed_id"],
};
</script>

<style lang="scss">
.game {
  background-image: url("../assets/bg_game.jpg");
  &__text {
    color: #fff;
  }
  .dot-block {
    bottom: 0;
    right: 0;
    opacity: 0.65;
    width: 50%;
    height: 100%;
  }

  &__embed {
    height: 801px;
    margin: 0 auto;
    width: 414px;

    iframe,
    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__header {

    &-text {
      font-size: 1.3125rem;
    }

    &-arrow {
      border-color: var(--color-primary) transparent transparent transparent;
      border-style: solid;
      border-width: 63px 94px 0 94px;
      top: 100%;
      height: 0;
      left: 50%;
      transform: translate(-50%, 0);
      width: 0;

      &-icon {
        left: 50%;
        top: -56px;
        transform: translate(-50%, -50%);
      }
    }
  }

  @media screen and (max-width: 767px) {
    &__embed {
      height: auto;
      width: 100%;
      padding-bottom: 177.778%;
    }
  }

  @media screen and (min-width: 1024px) {
    &__text {
      font-size: 1.5rem;
    }

    &__header {
      &-text {
        font-size: 2.25rem;
      }
    }
  }
}
</style>
